import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { AgreementTypes } from "@shared/enums/agreement-types";

@Component({
  selector: "app-contact-info-note",
  standalone: true,
  imports: [TranslateModule, CommonModule],
  templateUrl: "./contact-info-note.component.html",
})
export class ContactInfoNoteComponent {
  @Input() agreementTypes!: AgreementTypes;
  @Output() returnToPolicy = new EventEmitter<void>();
  AgreementTypes = AgreementTypes;

  onReturnToPolicy() {
    this.returnToPolicy.emit();
  }
}
